import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/redux';
import { selectUser } from '../../store/slices/authSlice';
import { getDefaultRouteForUser } from '../../utils/helpers';

/**
 * Component that redirects users to the appropriate page based on their permissions
 */
const SmartRedirect: React.FC = () => {
  const user = useAppSelector(selectUser);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Get user permissions and determine the best route
  const userPermissions = user.permissions?.map(p => p.name) || [];
  const defaultRoute = getDefaultRouteForUser(userPermissions);

  return <Navigate to={defaultRoute} replace />;
};

export default SmartRedirect;